import React from 'react';
import './Navbar.css';
import { LogOut, School } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const Navbar = () => {
  const { schoolName, user, logout } = useAuth();

  return (
    <nav className="app-navbar">
      <div className="container-fluid app-navbar-inner">
        <div className="app-brand">
          <div className="app-brand-logo">
            <img src="/logo192.png" alt="Alpho ID Solution" />
          </div>
          <div>
            <div className="app-brand-title">Alpho ID Solution</div>
            <div className="app-brand-subtitle">Student ID Management Workspace</div>
          </div>
        </div>

        <div className="app-navbar-user">
          <div className="app-user-chip">
            <School size={16} />
            <div>
              <div className="app-user-chip-title">{schoolName || 'Workspace'}</div>
              <div className="app-user-chip-subtitle">{user?.email}</div>
            </div>
          </div>

          <button type="button" className="btn btn-light app-logout-btn" onClick={logout}>
            <LogOut size={16} />
            <span>Logout</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
